'use client';

import { t } from '@lingui/macro';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import { Box, Button, Tooltip } from '@mui/material';
import { type FC, useMemo, useState, useTransition } from 'react';
import { useUpdateUserPrivacy } from '../../hooks/use-update-user-pricacy';
import type { PrivacyParamsSchemaT } from '../../utils/update-user';

type Props = {
  me: PrivacyParamsSchemaT;
};

export const PrivacySwitchMobileBtn: FC<Props> = (props) => {
  const { me } = props;
  const [privacyChecked, setprivacyChecked] = useState<boolean>(me.is_private);

  const { trigger: togglePrivacy, isMutating } = useUpdateUserPrivacy();

  const [isTransiting, startTransition] = useTransition();

  const privacyTexts = useMemo(() => {
    return privacyChecked
      ? {
          title: t`Profil non visible`,
          btn: t`Rendre visible`,
        }
      : {
          title: t`Profil visible`,
          btn: t`Privatiser`,
        };
  }, [privacyChecked]);

  const onTogglePrivacy = () => {
    const toggle = !privacyChecked;
    setprivacyChecked(toggle);
    const params: PrivacyParamsSchemaT = {
      id: me.id,
      is_private: toggle,
    };
    togglePrivacy(params, {
      onError: (error) => console.log('erreur', error),
      onSuccess: async () => {},
    });
  };

  return (
    <Tooltip title={isMutating ? '' : privacyTexts.title} placement="left">
      <Box component="span">
        <Button
          variant="outlined"
          color="primary"
          onClick={onTogglePrivacy}
          disabled={isMutating}
          sx={{
            minWidth: 'unset',
            padding: '0.25rem',
            backgroundColor: 'background.paper',
          }}
        >
          {privacyChecked && <LockTwoToneIcon />}
          {!privacyChecked && <LockOpenTwoToneIcon />}
        </Button>
      </Box>
    </Tooltip>
    // <IconButton
    //   aria-label="delete"
    //   color={privacyChecked ? 'primary' : 'default'}
    //   onClick={onTogglePrivacy}
    //   disabled={isMutating}
    //   sx={{
    //     width: '2rem',
    //     height: '2rem',
    //     borderRadius: 1_000_000,
    //     backgroundColor: 'paper',
    //     border: 'primary solid 1px',
    //   }}
    // >
    //   {privacyChecked && <LockTwoToneIcon />}
    //   {!privacyChecked && <LockOpenTwoToneIcon />}
    // </IconButton>
  );
};
